import { useTranslate } from "front";
import { translations } from "../../translations";

export const useCompanyTabs = () => {
  const t = useTranslate(translations);

  return { t };
};
